<template>
  <div class="return-sample-container">
    <el-card class="order-card">
      <div class="page-header">
        <h2>转寄样品</h2>
        <el-button @click="goBack">返回</el-button>
      </div>
      
      <el-form :model="returnForm" ref="returnForm" label-width="120px" :rules="returnRules" class="return-form" label-position="right">
        <el-divider content-position="left">
          <span class="divider-title">项目信息</span>
        </el-divider>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="订单号">
              <el-input v-model="returnForm.orderNo" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目名称">
              <el-input v-model="returnForm.projectInfo.name" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="样品数量">
              <el-input v-model="returnForm.projectInfo.sampleCount" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单状态">
              <el-tag :type="getStatusType(returnForm.status)" style="width: 100%; text-align: center;">{{ returnForm.status }}</el-tag>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input 
                type="textarea" 
                v-model="returnForm.projectInfo.remark" 
                :rows="3"
                disabled>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider content-position="left">
          <span class="divider-title">商家信息</span>
        </el-divider>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="商家名称">
              <el-input v-model="returnForm.merchantInfo.name" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人">
              <el-input v-model="returnForm.merchantInfo.contactPerson" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="联系方式">
              <el-input v-model="returnForm.merchantInfo.contactPhone" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商家地址">
              <el-input v-model="returnForm.merchantInfo.address" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider content-position="left">
          <span class="divider-title">客户信息</span>
        </el-divider>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="客户名称">
              <el-input v-model="returnForm.originalInfo.customerName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户联系人">
              <el-input v-model="returnForm.originalInfo.contactPerson" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="联系方式">
              <el-input v-model="returnForm.originalInfo.contactPhone" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户地址">
              <el-input v-model="returnForm.originalInfo.address" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider content-position="left">
          <span class="divider-title">转寄信息</span>
        </el-divider>
        
        <el-row :gutter="24" v-if="!isCustomerView">
          <el-col :span="12">
            <el-form-item label="快递公司" prop="logistics.company">
              <el-select v-model="returnForm.logistics.company" placeholder="请选择快递公司" style="width: 100%">
                <el-option
                  v-for="item in logisticsOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="快递单号" prop="logistics.trackingNo">
              <el-input v-model="returnForm.logistics.trackingNo" placeholder="请输入快递单号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="转寄时间" prop="logistics.shipTime">
              <el-date-picker
                v-model="returnForm.logistics.shipTime"
                type="datetime"
                placeholder="选择转寄时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="转寄样品数量" prop="returnForwardCount">
              <el-input v-model="returnForm.returnForwardCount" placeholder="转寄样品数量"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="转寄原因" prop="reason">
              <el-input 
                type="textarea" 
                v-model="returnForm.reason" 
                :rows="3"
                placeholder="请输入转寄原因"
                class="consistent-style">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <div class="form-footer">
          <el-button type="primary" @click="submitForm">提交</el-button>
          <el-button @click="goBack">取消</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'ForwardSample',
  data() {
    return {
      orderId: '',
      orderSn: '',
      logisticsOptions: [],
      isCustomerView: false,
      returnForm: {
        orderNo: '',
        status: '',
        reason: '',
        returnForwardCount: '',
        logistics: {
          company: '',
          trackingNo: '',
          shipTime: ''
        },
        projectInfo: {
          name: '',
          remark: '',
          sampleCount: 1
        },
        merchantInfo: {
          id: '',
          name: '',
          contactPerson: '',
          contactPhone: '',
          address: ''
        },
        originalInfo: {
          customerName: '',
          contactPerson: '',
          contactPhone: '',
          address: ''
        },
        remark: ''
      },
      returnRules: {
        reason: [{ required: true, message: '请输入转寄原因', trigger: 'blur' }],
        returnForwardCount: [{ required: true, message: '请输入转寄样品数量', trigger: 'blur' }],
        'logistics.company': [{ required: true, message: '请选择快递公司', trigger: 'change' }],
        'logistics.trackingNo': [{ required: true, message: '请输入快递单号', trigger: 'blur' }],
        'logistics.shipTime': [{ required: true, message: '请选择转寄时间', trigger: 'change' }]
      }
    }
  },
  created() {
    // 从路由获取订单ID
    this.orderId = this.$route.params.id
    
    // 检查是否是客户端访问
    this.isCustomerView = window.location.pathname.includes('/customer/') || localStorage.getItem('userRole') === 'customer';
    
    if (this.orderId) {
      this.fetchOrderInfo()
      // 获取物流公司列表
      this.fetchLogisticsList()
    } else {
      this.$message.error('没有找到订单信息')
      this.goBack()
    }
  },
  methods: {
    // 获取物流公司列表
    async fetchLogisticsList() {
      try {
        const res = await adminApi.getLogisticsList()
        if (res && Array.isArray(res)) {
          // 转换为select需要的格式
          this.logisticsOptions = res.map(item => ({
            value: item.trackCode,
            label: item.trackName
          }))
        } else {
          this.$message.warning('获取物流公司列表失败')
        }
      } catch (error) {
        console.error('获取物流公司列表错误:', error)
        this.$message.error('获取物流公司列表失败: ' + (error.message || '未知错误'))
      }
    },
    
    // 获取订单状态对应的类型
    getStatusType(status) {
      const typeMap = {
        '未邮寄': 'info',
        '已邮寄': 'warning',
        '测试中': 'primary',
        '已完成': 'success',
        '已取消': 'danger',
        '已测试': 'success'
      }
      return typeMap[status] || 'info'
    },
    
    // 订单状态映射
    mapOrderStatus(status) {
      const statusMap = {
        'NOT_SHIPPED': '未邮寄',
        'SHIPPED': '已邮寄',
        'IN_TRANSIT': '运输中',
        'TESTING': '测试中',
        'COMPLETED': '已完成',
        'CANCELED': '已取消',
        'TESTED': '已测试'
      }
      return statusMap[status] || status
    },
    
    async fetchOrderInfo() {
      try {
        this.$loading({
          lock: true,
          text: '加载订单信息...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        
        // 获取订单信息
        const res = await adminApi.getOrderById(this.orderId)
        console.log(res)
        
        this.$loading().close()
        
        if (res) {
          const orderData = res
          this.orderSn = orderData.orderSn
          
          // 获取当前时间作为转寄时间
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, '0');
          const day = String(now.getDate()).padStart(2, '0');
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');
          const seconds = String(now.getSeconds()).padStart(2, '0');
          const currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
          
          // 填充表单基本信息
          this.returnForm = {
            orderNo: orderData.orderSn,
            status: this.mapOrderStatus(orderData.orderStatus) || '未邮寄',
            reason: '',
            returnForwardCount: orderData.testCount || 1,
            logistics: {
              company: '',
              trackingNo: '',
              shipTime: currentTime // 设置转寄时间为当前时间
            },
            projectInfo: {
              name: orderData.projectName || '',
              remark: orderData.remarks || '',
              sampleCount: orderData.testCount || 1
            },
            merchantInfo: {
              id: orderData.merchantId || '',
              name: orderData.merchantName || '',
              contactPerson: orderData.merchantPerson || '',
              contactPhone: orderData.merchantPhone || '',
              address: orderData.merchantAddress || ''
            },
            originalInfo: {
              customerName: orderData.customerName || '',
              contactPerson: orderData.customerPerson || '',
              contactPhone: orderData.customerPhone || '',
              address: orderData.customerAddress || ''
            },
            remark: ''
          }
        } else {
          this.$message.error(res.data ? res.data.msg : '获取订单信息失败')
          this.goBack()
        }
      } catch (error) {
        this.$loading().close()
        this.$message.error('获取订单信息失败: ' + (error.message || '未知错误'))
        this.goBack()
      }
    },
    submitForm() {
      this.$refs.returnForm.validate(async valid => {
        if (valid) {
          // 管理端需要验证快递信息
          if (!this.isCustomerView) {
            if (!this.returnForm.logistics.company || !this.returnForm.logistics.trackingNo) {
              this.$message.error('请填写完整的物流信息')
              return
            }
          }
          
          try {
            this.$loading({
              lock: true,
              text: '提交转寄申请...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            
            // 构造提交数据，按照后台接口要求
            const submitData = {
              orderSn: this.returnForm.orderNo,
              // 转寄为0
              isReturnForward: 0,
              isForwardOrder: -1,
              // 其他信息
              reason: this.returnForm.reason,
              returnForwardTime: this.returnForm.logistics.shipTime,
              returnForwardCount: this.returnForm.returnForwardCount
            }
            
            // 如果是管理端，添加物流信息
            if (!this.isCustomerView) {
              submitData.trackSn = this.returnForm.logistics.trackingNo;
              submitData.trackName = this.getTrackCompanyName(this.returnForm.logistics.company);
            }
            
            // 提交转寄样品请求
            const res = await adminApi.applyForward(submitData)
            
            this.$loading().close()
            
            if (res) {
              this.$message({
                message: this.isCustomerView ? '转寄样品申请提交成功' : '转寄信息提交成功',
                type: 'success'
              })
              
              // 根据用户角色决定跳转路径
              const userRole = localStorage.getItem('userRole')
              if (userRole === 'customer') {
                // 客户端跳转到客户的订单页面
                setTimeout(() => {
                  this.$router.push('/customer/orders/return')
                }, 1500)
              } else if (userRole === 'merchant') {
                // 商家端跳转到商家的订单页面
                setTimeout(() => {
                  this.$router.push('/merchant/orders/return')
                }, 1500)
              } else {
                // 管理员端跳转到管理员的订单页面
                setTimeout(() => {
                  this.$router.push('/admin/orders/return')
                }, 1500)
              }
            } else {
              this.$message.error(res.msg || '提交失败')
            }
          } catch (error) {
            this.$loading().close()
            this.$message.error('提交失败: ' + (error.message || '未知错误'))
          }
        }
      })
    },
    
    // 根据快递公司代码获取快递公司名称
    getTrackCompanyName(code) {
      const company = this.logisticsOptions.find(item => item.value === code)
      return company ? company.label : code
    },
    
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.return-sample-container {
  padding: 30px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.order-card {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.page-header h2 {
  margin: 0;
  color: #303133;
  font-size: 24px;
}

.divider-title {
  font-size: 18px;
  font-weight: bold;
  color: #409EFF;
  position: relative;
  padding-left: 12px;
}

.divider-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 18px;
  width: 4px;
  background-color: #409EFF;
  border-radius: 2px;
}

.return-form {
  max-width: 100%;
}

.el-form-item {
  margin-bottom: 24px;
}

.el-form-item__label {
  font-weight: bold;
  color: #606266;
  white-space: nowrap;
  padding-right: 10px;
}

.return-method-item {
  margin-bottom: 24px;
}

.radio-group {
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 40px;
}

.custom-radio {
  min-width: 80px;
  margin-right: 15px;
  display: flex;
  align-items: center;
}

.custom-radio /deep/ .el-radio__label {
  font-size: 14px;
  padding-left: 8px;
  line-height: 40px;
}

.custom-radio /deep/ .el-radio__input {
  line-height: 40px;
  display: flex;
  align-items: center;
}

.form-footer {
  margin-top: 40px;
  text-align: center;
}

.form-footer .el-button {
  min-width: 120px;
  margin: 0 10px;
}

.el-textarea.consistent-style /deep/ .el-textarea__inner {
  font-family: inherit;
  font-size: 14px;
  color: #606266;
  line-height: 1.5;
}

.el-input.consistent-style /deep/ .el-input__inner {
  font-family: inherit;
  font-size: 14px;
  color: #606266;
}

/* 确保disabled状态的输入框也保持一致的样式 */
.el-input.is-disabled /deep/ .el-input__inner,
.el-textarea.is-disabled /deep/ .el-textarea__inner {
  color: #606266;
  background-color: #f5f7fa;
}
</style> 